/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmi_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does BMI apply to children and teenagers?`)
};

const es_bmi_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Se aplica el IMC a niños y adolescentes?`)
};

const de_bmi_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gilt BMI für Kinder und Jugendliche?`)
};

const nl_bmi_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geldt BMI voor kinderen en tieners?`)
};

const fr_bmi_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'IMC s'applique-t-il aux enfants et aux adolescents ?`)
};

const it_bmi_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il BMI si applica a bambini e adolescenti?`)
};

const pt_br2_bmi_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMI se aplica a crianças e adolescentes?`)
};

const pt_bmi_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O IMC aplica-se a crianças e adolescentes?`)
};

const ja_bmi_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMIは子どもと十代の若者に適用されますか？`)
};

const zh_bmi_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMI 适用于儿童和青少年吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmi_hub_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmi_hub_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmi_hub_faq4_q", locale)
	if (locale === "en") return en_bmi_hub_faq4_q(inputs)
	if (locale === "es") return es_bmi_hub_faq4_q(inputs)
	if (locale === "de") return de_bmi_hub_faq4_q(inputs)
	if (locale === "nl") return nl_bmi_hub_faq4_q(inputs)
	if (locale === "fr") return fr_bmi_hub_faq4_q(inputs)
	if (locale === "it") return it_bmi_hub_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_bmi_hub_faq4_q(inputs)
	if (locale === "pt") return pt_bmi_hub_faq4_q(inputs)
	if (locale === "ja") return ja_bmi_hub_faq4_q(inputs)
	return zh_bmi_hub_faq4_q(inputs)
};